query getContentList($type: String, $customFilters: [String!]) {
  propsContentList(type: $type, activatedOrFinishedProgram: false, customFilters: $customFilters) {
    id
    props
    images {
      id
      compressedImage {
        webp {
          lg
          md
          sm
          xl
          xs
        }
      }
    }
  }
}
